export function validateLink(link) {
  if (!link || link == '') return '';
  let newLink;
  if (!link.includes('//')) {
    newLink = 'https://' + link;
  } else {
    newLink = link;
  }
  return newLink;
}
